import { type Module } from "vuex";
import type { State as RootState } from "@/stores";
import type { DefaultApi } from "@/api";

export interface State {
  sources?: string[];
}

export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    sources: undefined,
  },
  actions: {
    async getCandidateSources({ commit }) {
      const api = (await this.dispatch("getAuthorizedApi", null, {
        root: true,
      })) as DefaultApi;
      const response = await api.getCandidateSources();
      const sources = response.data ?? [];
      commit("setSources", sources);
      return sources;
    },
  },
  mutations: {
    setSources(state, sources: string[]) {
      state.sources = sources;
    },
  },
};
